import config from './config';

/* eslint-disable no-param-reassign */
export function merge(obj, src) {
  Object.keys(src).forEach((key) => {
    if (obj[key] && typeof obj[key] === 'object') {
      merge(obj[key], src[key]);
      return;
    }
    obj[key] = src[key];
  });

  return obj;
}
/* eslint-enable no-param-reassign */

export function updateConfig(params) {
  merge(config, params);
}

export function isRouteIgnored({ name, path }) {
  return [name, path]
    .filter(Boolean)
    .find((value) => config.routeTrack.ignoreRoutes.indexOf(value) !== -1);
}

export function isRoute(data) {
  return data.query && data.params;
}

export function isRouter(data) {
  return data.currentRoute;
}

/* eslint-disable no-param-reassign */
export function getQueryString(queryMap) {
  const queryString = Object.keys(queryMap)
    .reduce((string, key, index, keys) => {
      const isLastKey = index === (keys.length - 1);
      string += `${key}=${queryMap[key]}${isLastKey ? '' : '&'}`;
      return string;
    }, '');

  return queryString !== '' ? `?${queryString}` : '';
}
/* eslint-enable no-param-reassign */

export function getBasePath(base, path) {
  const pathAsArray = path.split('/');
  const baseAsArray = base.split('/');

  if (pathAsArray[0] === '' && base[base.length - 1] === '/') {
    pathAsArray.shift();
  }

  return baseAsArray.join('/') + pathAsArray.join('/');
}
